import { Label8 } from "@/src/components/typography/components/Label";
import clsx from "clsx";
import { PropsWithChildren } from "react";

const ProfileLabel = ({
  children,
  className,
}: PropsWithChildren & { className?: string }) => (
  <Label8
    className={clsx(
      "whitespace-nowrap text-gray-950 bg-white px-[6px] w-fit h-fit",
      className,
    )}
  >
    {children}
  </Label8>
);

export default ProfileLabel;
